// Globally load all the font awesome icons were going to use.
// this will allow us to not have to add individual icons per each file
// while also having a limited load of explicit set icons from a well
// maintained and broad set
import { library } from '@fortawesome/fontawesome-svg-core';

// Importing brand icons from free-brands-svg-icons
// I guess there isn't a pro bands to use
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faAirbnb } from '@fortawesome/free-brands-svg-icons';

// Importing regular icons from pro-regular-svg-icons
import {
  faAlignCenter,
  faAlignLeft,
  faAlignRight,
  faArrowDown,
  faArrowsAlt,
  faBan,
  faBriefcase,
  faBuilding,
  faCalendar,
  faChartLine,
  faChartPie,
  faCheck,
  faChevronDown,
  faChevronUp,
  faCircle,
  faCircleNotch,
  faCloud,
  faCog,
  faComment,
  faComments,
  faCommenting,
  faCopy,
  faDownload,
  faDrawPolygon,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faEraser,
  faExclamationTriangle,
  faEye,
  faHouse,
  faHouseChimneyWindow,
  faList,
  faListAlt,
  faLink,
  faLongArrowDown,
  faLongArrowUp,
  faMailbox,
  faMap,
  faMessage,
  faMessageSms,
  faPaperclip,
  faPhone,
  faPhoneAlt,
  faPhoneSlash,
  faPlus,
  faPlusSquare,
  faRefresh,
  faSearch,
  faSignsPost,
  faSquare,
  faTh,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrophy,
  faUpload,
  faUser,
  faUserPlus,
  faVoicemail,
  faUndo,
  faRedo,
  faCode,
  faSquareEnvelope,
  faPaperPlane,
  faNotes,
  faNoteSticky,
  faDollarSign,
  faPen,
  faMobileAlt,
  faM,
  faBadgeCheck,
} from '@fortawesome/pro-regular-svg-icons';

// Importing solid icons from pro-solid-svg-icons
import {
  faAlignCenter as faAlignCenterSolid,
  faAlignLeft as faAlignLeftSolid,
  faAlignRight as faAlignRightSolid,
  faArrowDown as faArrowDownSolid,
  faArrowRight as faArrowRightSolid,
  faArrowsAlt as faArrowsAltSolid,
  faBan as faBanSolid,
  faBell as faBellSolid,
  faBolt as faBoltSolid,
  faBriefcase as faBriefcaseSolid,
  faBuilding as faBuildingSolid,
  faCalendar as faCalendarSolid,
  faChartLine as faChartLineSolid,
  faChartPie as faChartPieSolid,
  faCheck as faCheckSolid,
  faChevronDown as faChevronDownSolid,
  faChevronLeft as faChevronLeftSolid,
  faChevronRight as faChevronRightSolid,
  faChevronUp as faChevronUpSolid,
  faCircle as faCircleSolid,
  faCircleNotch as faCircleNotchSolid,
  faCloud as faCloudSolid,
  faCloudUpload as faCloudUploadSolid,
  faCog as faCogSolid,
  faComment as faCommentSolid,
  faComments as faCommentsSolid,
  faCommenting as faCommentingSolid,
  faCopy as faCopySolid,
  faDownload as faDownloadSolid,
  faDrawPolygon as faDrawPolygonSolid,
  faEdit as faEditSolid,
  faEllipsisV as faEllipsisVSolid,
  faEnvelope as faEnvelopeSolid,
  faEraser as faEraserSolid,
  faExclamationTriangle as faExclamationTriangleSolid,
  faEye as faEyeSolid,
  faFileAlt as faFileAltSolid,
  faFolder as faFolderSolid,
  faFolderMusic as faFolderMusicSolid,
  faHouse as faHouseSolid,
  faHouseChimneyWindow as faHouseChimneyWindowSolid,
  faList as faListSolid,
  faListAlt as faListAltSolid,
  faListTree as faListTreeSolid,
  faLink as fasLink,
  faLongArrowDown as faLongArrowDownSolid,
  faLongArrowUp as faLongArrowUpSolid,
  faMailbox as faMailboxSolid,
  faMap as faMapSolid,
  faMessage as faMessageSolid,
  faMessageImage as faMessageImageSolid,
  faMessageLines as faMessageLinesSolid,
  faMessageSms as faMessageSmsSolid,
  faMinus as faMinusSolid,
  faOctagonCheck as faOctagonCheckSolid,
  faPaperclip as faPaperclipSolid,
  faPenToSquare as faPenToSquareSolid,
  faPhone as faPhoneSolid,
  faPhoneAlt as faPhoneAltSolid,
  faPhoneSlash as faPhoneSlashSolid,
  faPlus as faPlusSolid,
  faPlusSquare as faPlusSquareSolid,
  faRefresh as faRefreshSolid,
  faSearch as faSearchSolid,
  faShoppingBag as faShoppingBagSolid,
  faSignsPost as faSignsPostSolid,
  faShareNodes as faShareNodesSolid,
  faSpinner as faSpinnerSolid,
  faSquare as faSquareSolid,
  faSquareUpRight as faSquareUpRightSolid,
  faTags as faTagsSolid,
  faTh as faThSolid,
  faTimes as faTimesSolid,
  faTimesCircle as faTimesCircleSolid,
  faTrash as faTrashSolid,
  faTrophy as faTrophySolid,
  faUpload as faUploadSolid,
  faUser as faUserSolid,
  faUserPlus as faUserPlusSolid,
  faVoicemail as faVoicemailSolid,
  faUndo as faUndoSolid,
  faRedo as faRedoSolid,
  faCode as faCodeSolid,
  faSquareEnvelope as faSquareEnvelopeSolid,
  faPaperPlane as faPaperPlaneSolid,
  faNotes as faNotesSolid,
  faNoteSticky as faNoteStickySolid,
  faDollarSign as faDollarSignSolid,
  faPen as faPenSolid,
  faMobileAlt as faMobileAltSolid,
  faBadgeCheck as faBadgeCheckSolid,
} from '@fortawesome/pro-solid-svg-icons';

// Adding all icons to the library in one call
library.add(
  faAirbnb,
  faWhatsapp,
  // Regular icons
  faAlignCenter,
  faAlignLeft,
  faAlignRight,
  faArrowDown,
  faArrowsAlt,
  faBan,
  faBriefcase,
  faBuilding,
  faCalendar,
  faChartLine,
  faCheck,
  faChevronDown,
  faChevronUp,
  faCircle,
  faCircleNotch,
  faCloud,
  faCog,
  faComment,
  faComments,
  faCommenting,
  faCopy,
  faDownload,
  faDrawPolygon,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faEraser,
  faExclamationTriangle,
  faEye,
  faHouse,
  faHouseChimneyWindow,
  faList,
  faListAlt,
  faLink,
  faLongArrowDown,
  faLongArrowUp,
  faMailbox,
  faMap,
  faMessage,
  faMessageSms,
  faPhone,
  faPhoneAlt,
  faPhoneSlash,
  faPlus,
  faPlusSquare,
  faRefresh,
  faSearch,
  faSignsPost,
  faSquare,
  faSquareUpRightSolid,
  faTh,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrophy,
  faUpload,
  faUser,
  faUserPlus,
  faVoicemail,
  faUndo,
  faRedo,
  faCode,
  faSquareEnvelope,
  faPaperPlane,
  faPaperclip,
  faNotes,
  faNoteSticky,
  faDollarSign,
  faPen,
  faMobileAlt,
  faBadgeCheck,
  // Solid icons
  faAlignCenterSolid,
  faAlignLeftSolid,
  faAlignRightSolid,
  faArrowDownSolid,
  faArrowRightSolid,
  faArrowsAltSolid,
  faBanSolid,
  faBellSolid,
  faBoltSolid,
  faBriefcaseSolid,
  faBuildingSolid,
  faCalendarSolid,
  faChartLineSolid,
  faChartPieSolid,
  faCheckSolid,
  faChevronDownSolid,
  faChevronLeftSolid,
  faChevronRightSolid,
  faChevronUpSolid,
  faCircleNotchSolid,
  faCircleSolid,
  faCloudSolid,
  faCloudUploadSolid,
  faCogSolid,
  faCommentSolid,
  faCommentsSolid,
  faCommentingSolid,
  faCopySolid,
  faDownloadSolid,
  faEditSolid,
  faEllipsisVSolid,
  faEnvelopeSolid,
  faExclamationTriangleSolid,
  faEyeSolid,
  faFileAltSolid,
  faFolderSolid,
  faFolderMusicSolid,
  faHouseChimneyWindowSolid,
  faHouseSolid,
  faListAltSolid,
  faListSolid,
  faListTreeSolid,
  fasLink,
  faLongArrowDownSolid,
  faLongArrowUpSolid,
  faMailboxSolid,
  faMapSolid,
  faMessageImageSolid,
  faMessageLinesSolid,
  faMessageSmsSolid,
  faMessageSolid,
  faMinusSolid,
  faOctagonCheckSolid,
  faPenToSquareSolid,
  faPhoneAltSolid,
  faPhoneSlashSolid,
  faPhoneSolid,
  faPlusSolid,
  faPlusSquareSolid,
  faRefreshSolid,
  faSearchSolid,
  faShoppingBagSolid,
  faShareNodesSolid,
  faSignsPostSolid,
  faSpinnerSolid,
  faTagsSolid,
  faThSolid,
  faTimesCircleSolid,
  faTimesSolid,
  faTrashSolid,
  faTrophySolid,
  faUploadSolid,
  faUserPlusSolid,
  faUserSolid,
  faVoicemailSolid,
  faUndoSolid,
  faRedoSolid,
  faCodeSolid,
  faSquareEnvelopeSolid,
  faPaperPlaneSolid,
  faPaperclipSolid,
  faNotesSolid,
  faNoteStickySolid,
  faDollarSignSolid,
  faPenSolid,
  faMobileAltSolid,
  faBadgeCheckSolid,
  faDrawPolygonSolid,
  faEraserSolid,
  faSquareSolid
);
